<nz-layout class="app-layout">
  <nz-layout>
    <nz-layout>
      <nz-sider
        [nzCollapsible]="isSmall() ? true : false"
        [(nzCollapsed)]="isCollapsed"
        [nzWidth]="isSmall() ? '200px' : '250px'"
        [class]="isSmall() ? 'handset-sider' : 'desktop-sider'"
      >
        <div
          class="project-item"
          [matTooltip]="'Config Workspace and Profile'"
          nz-dropdown
          nzTrigger="click"
          [nzDropdownMenu]="projectMenu"
        >
          <div class="horizontal full-width project">
            <app-text-icon
              [name]="currentWorkspace().title"
              [size]="40"
              [backgroundColor]="currentWorkspace().settings?.backgroundColor"
            ></app-text-icon>

            @if (!isSmall()) {
              <div class="horizontal seperate full-width">
                <div class="project-name vertical">
                  <span>{{ workspaceName() }}</span>
                  <span class="first-name">{{ firstName() }}</span>
                </div>
              </div>
            }
          </div>
        </div>

        <nz-dropdown-menu #projectMenu="nzDropdownMenu">
          <ul nz-menu nzMode="inline">
            <li nz-menu-item (click)="onProjectSettingsClick()">
              <div class="horizontal">
                <div class="horizontal">
                  <span nz-icon style="font-size: 18px" class="material-symbols-rounded">settings</span>
                  <span>Workspace Settings</span>
                </div>
              </div>
            </li>

            @if (paidStatus()?.type === StripeProductType.premium) {
              <li nz-menu-item (click)="onMembersClick()">
                <div class="horizontal">
                  <div class="horizontal">
                    <span nz-icon style="font-size: 18px" class="material-symbols-rounded">group</span>
                    <span>Members</span>
                  </div>
                </div>
              </li>
            } @else {
              <li nz-menu-item [matTooltip]="'Premium Feature'">
                <div class="horizontal full-width is-locked seperate">
                  <div class="horizontal">
                    <span nz-icon style="font-size: 18px" class="material-symbols-rounded">group</span>
                    <span>Members</span>
                  </div>

                  <span nz-icon style="font-size: 18px" class="material-symbols-rounded">lock</span>
                </div>
              </li>
            }

            <li nz-menu-item (click)="onSwitchWorkspacesClick()">
              <div class="horizontal">
                <div class="horizontal">
                  <span nz-icon style="font-size: 18px" class="material-symbols-rounded">sync_alt</span>
                  <span>Switch Workspaces</span>
                </div>
              </div>
            </li>

            <li nz-menu-divider></li>
            <li nz-menu-item (click)="onMyAccountClick()">
              <div class="horizontal">
                <nz-avatar class="portrait" [nzSrc]="portraitUrl()" [nzShape]="'circle'"></nz-avatar>
                <span>My Account</span>
              </div>
            </li>

            <li nz-menu-item (click)="onUsageBillingClick()">
              <div class="horizontal">
                <div class="horizontal">
                  <span nz-icon style="font-size: 18px" class="material-symbols-rounded">account_balance_wallet</span>
                  <span>Usage & Billing</span>
                </div>
              </div>
            </li>

            <li nz-menu-item (click)="onLogoutClick()">
              <div class="horizontal">
                <span nz-icon style="font-size: 18px" class="material-symbols-rounded">logout</span>
                <span>Logout</span>
              </div>
            </li>
          </ul>
        </nz-dropdown-menu>
        <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
          <li
            nz-menu-item
            nzMatchRouter
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isSmall() ? 'Home' : null"
          >
            <a class="horizontal gap-zero" [routerLink]="['/', 'home']">
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">home</span>
              <span class="menu-text">Home</span>
            </a>
          </li>
          <li
            nz-menu-item
            nzMatchRouter
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isSmall() ? 'Assignments' : null"
          >
            <a class="horizontal gap-zero" [routerLink]="['/', 'assignments']">
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">event_list</span>
              <span class="menu-text">Assignments</span>
            </a>
          </li>
          <li
            nz-menu-item
            nzMatchRouter
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isSmall() ? 'Scenario Library' : null"
          >
            <a class="horizontal gap-zero" [routerLink]="['/', 'scenario-library']">
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">assignment_ind</span>
              <span class="menu-text">Scenario Library</span>
            </a>
          </li>
          <!-- <li nz-submenu [nzTitle]="titleAiProfiles" [nzOpen]="true">
              <ng-template #titleAiProfiles>
                <div class="horizontal gap-zero">
                  <span nz-icon style="font-size: 18px" class="material-symbols-rounded">assignment_ind</span>
                  <span>Scenario Library</span>
                </div>
              </ng-template>
              <ul>
                <li class="menu-item" nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'simulated-meetings']">
                    <span class="menu-text">AI Profile</span>
                  </a>
                </li>
                <li class="menu-item" nz-menu-item nzMatchRouter>
                  <a [routerLink]="['/', 'simulated-meetings']">
                    <span class="menu-text">Customer Profile</span>
                  </a>
                </li>
              </ul>
            </li> -->
          <li nz-submenu [nzTitle]="titleCallLibrary" [nzOpen]="isCallLibraryOpen()">
            <ng-template #titleCallLibrary>
              <div class="horizontal gap-zero">
                <span nz-icon style="font-size: 18px" class="material-symbols-rounded">library_books</span>
                <span>Call Library</span>
              </div>
            </ng-template>
            <ul>
              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'simulated-meetings']">
                  <span class="menu-text">Simulated Meetings</span>
                </a>
              </li>
              <app-menu-item [title]="'Real Meetings'"></app-menu-item>
            </ul>
          </li>
          <li nz-submenu [nzTitle]="titleMyMaterial" [nzOpen]="isMyMaterialsOpen()">
            <ng-template #titleMyMaterial>
              <div class="horizontal gap-zero">
                <span nz-icon style="font-size: 18px" class="material-symbols-rounded">file_present</span>
                <span>My Materials</span>
              </div>
            </ng-template>
            <ul>
              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'customers']">
                  <span class="menu-text">Customers</span>
                </a>
              </li>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'products']">
                  <span class="menu-text">Products</span>
                </a>
              </li>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'objections']">
                  <span class="menu-text">Objections & Questions</span>
                </a>
              </li>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'methodologies']">
                  <span class="menu-text">Methodologies</span>
                </a>
              </li>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'goals']">
                  <span class="menu-text">Goals</span>
                </a>
              </li>

              <!-- <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'tags']">
                  <span class="menu-text">Tags</span>
                </a>
              </li> -->
            </ul>
          </li>
          <li nz-submenu [nzTitle]="titleAnalytics" [nzOpen]="isAnalyticsOpen()">
            <ng-template #titleAnalytics>
              <div class="horizontal gap-zero">
                <span nz-icon style="font-size: 18px" class="material-symbols-rounded">analytics</span>
                <span>Analytics</span>
              </div>
            </ng-template>
            <ul>
              <app-menu-item [title]="'Leaderboard'"></app-menu-item>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'reports']">
                  <span class="menu-text">Reports</span>
                </a>
              </li>
            </ul>
          </li>

          <li nz-submenu [nzTitle]="titleLeads" [nzOpen]="isMyMaterialsOpen()">
            <ng-template #titleLeads>
              <div class="horizontal gap-zero">
                <span nz-icon style="font-size: 18px" class="material-symbols-rounded">groups</span>
                <span>Leads</span>
              </div>
            </ng-template>
            <ul>
              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'leads-invitation']">
                  <span class="menu-text">Invitation</span>
                </a>
              </li>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'leads-first-message']">
                  <span class="menu-text">First Message</span>
                </a>
              </li>

              <li class="menu-item" nz-menu-item nzMatchRouter>
                <a [routerLink]="['/', 'leads-reports']">
                  <span class="menu-text">Reports</span>
                </a>
              </li>
            </ul>
          </li>

          <li
            nz-menu-item
            nzMatchRouter
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isSmall() ? 'Download Chrome Extension' : null"
          >
            <a
              class="horizontal gap-zero"
              href="https://chromewebstore.google.com/detail/peak-mojo/ellfmoopomppmhljhjkbmninmnkoebfn?hl=en-US&utm_source=ext_sidebar"
              target="_blank"
            >
              <span nz-icon style="font-size: 18px" class="material-symbols-rounded">extension</span>
              <span class="menu-text">Chrome Extension</span>
            </a>
          </li>
        </ul>
        <div class="version">
          {{ version() }}
        </div>
      </nz-sider>
      <nz-layout [ngClass]="isSmall() ? ['right-layout-mobile'] : ['right-layout']">
        <!-- <nz-header>
          <div class="app-header">
            @if (isMobile()) {
              <div class="logo logo-handset">
                <a [routerLinkArr]="['/']">
                  <img src="/assets/icons/logo.png" alt="logo" />
                  <h1>
                    <span class="text"> Peak Mojo</span>
                  </h1>
                </a>
              </div>
            } @else {
              <div class="logo logo-normal">
                <a [routerLinkArr]="['/']">
                  <img src="/assets/icons/logo.png" alt="logo" />
                  <h1>
                    <span class="text"> Peak Mojo</span>
                  </h1>
                </a>
              </div>
            }

            <div class="buttons">
              @if (isMobile()) {
                <button class="credit-btn" nz-button nzType="text" nzSize="small" (click)="onPointsClick()">
                  <span>{{ credits() }} points</span>
                </button>
              }

              <nz-avatar
                class="portrait"
                [nzSrc]="portraitUrl()"
                nz-dropdown
                [nzDropdownMenu]="portraitMenu"
                [nzShape]="'circle'"
              ></nz-avatar>

              <nz-dropdown-menu #portraitMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="onMyAccountClick()">
                    <div class="horizontal">
                      <span nz-icon style="font-size: 18px" class="material-symbols-rounded">account_circle</span>
                      <span>My Account</span>
                    </div>
                  </li>
                  <li nz-menu-item (click)="onWalletClick()">
                    <div class="horizontal">
                      <span nz-icon style="font-size: 18px" class="material-symbols-rounded"
                        >account_balance_wallet</span
                      >
                      <span>History</span>
                    </div>
                  </li>
                  <li nz-menu-item (click)="onLogoutClick()">
                    <div class="horizontal">
                      <span nz-icon style="font-size: 18px" class="material-symbols-rounded">logout</span>
                      <span>Logout</span>
                    </div>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>
          </div>
        </nz-header> -->
        <nz-content>
          <div class="body-content" [ngClass]="isSmall() ? ['body-content-handset'] : ['body-content-normal']">
            <ng-content></ng-content>
          </div>
        </nz-content>
        <nz-footer>
          <div class="footer">Copyright ©2024 Peak Mojo AI. All rights reserved.</div>
        </nz-footer>
      </nz-layout>
    </nz-layout>
  </nz-layout>
</nz-layout>

<nz-modal
  [(nzVisible)]="isSendFeedbackVisible"
  nzTitle="Contact Support"
  (nzOnCancel)="handleSendFeedbackCancel()"
  [nzOkText]="'Send'"
  (nzOnOk)="handleSendFeedbackOk()"
>
  <ng-container *nzModalContent>
    <div class="vertical-large">
      <div class="vertical">
        <div class="field-name">Name</div>
        <input nz-input placeholder="Name" [(ngModel)]="name" />
      </div>

      <div class="vertical">
        <div class="field-name">Email</div>
        <input nz-input placeholder="Email" [(ngModel)]="email" />
      </div>

      <div class="vertical">
        <div class="field-name">Feedback</div>
        <textarea
          nz-input
          placeholder="Feedback"
          [(ngModel)]="feedback"
          [nzAutosize]="{ minRows: 2, maxRows: 6 }"
        ></textarea>
      </div>
    </div>
  </ng-container>
</nz-modal>
